import React from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../redux/modules/bodega/bodega";
import { actions as ingresoActions } from "../../../../redux/modules/bodega/ingreso";
import Ingreso from './Ingreso';

const LOCALSTORAGE_KEY = "bodega_seleccionados";

function saveSeleccionadosToLocalStorage(seleccionados) {
    try {
        localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(seleccionados));
    } catch (e) {}
}

function getSeleccionadosFromLocalStorage() {
    try {
        const data = localStorage.getItem(LOCALSTORAGE_KEY);
        return data ? JSON.parse(data) : [];
    } catch (e) {
        return [];
    }
}

function clearSeleccionadosLocalStorage() {
    try {
        localStorage.removeItem(LOCALSTORAGE_KEY);
    } catch (e) {}
}

const ms2p = (state) => {
    let total = 0;
    state.bodega.seleccionados.forEach((producto) => {
        const costo = producto.costo ? parseFloat(producto.costo) : 0;
        const cantidad = producto.ingreso ? parseFloat(producto.ingreso) : 0;
        total = total + (costo * cantidad);
    });
    return {
        ...state.bodega,
        // conf_empresa: state.configuracion.config,
        sucursal: state.usuario.sucursal,
        pais: state.usuario.me.pais,
        conf_empresa: state.usuario,
        total,
        conf_habilitar_no_factura: state.usuario.me.conf_habilitar_no_factura,
        conf_tipo_negocio:
            state.configuracion && state.configuracion.config
                ? state.configuracion.config.conf_tipo_negocio
                : false, 
    };
};

const md2p = (dispatch, getState) => {
    // Acciones originales
    const allActions = { ...actions, ...ingresoActions };

    // Envolver acciones que modifican seleccionados
    const wrapAndSave = (actionName) => (...args) => {
        const result = dispatch(allActions[actionName](...args));
        setTimeout(() => {
            const state = dispatch((_, getState) => getState());
            saveSeleccionadosToLocalStorage(state.bodega.seleccionados);
        }, 0);
        return result;
    };

    // Lista de acciones que deben actualizar localStorage
    const accionesSeleccionados = [
        "agregar",
        "quitar",
        "setSeleccionados",
        "asignarIngreso", 
    ];

    const wrappedActions = {};
    Object.keys(allActions).forEach(key => {
        if (accionesSeleccionados.includes(key)) {
            wrappedActions[key] = wrapAndSave(key);
        } else {
            wrappedActions[key] = (...args) => dispatch(allActions[key](...args));
        }
    });

    // Limpiar localStorage al finalizar/cancelar
    wrappedActions.efectuarIngreso = (...args) => {
        const result = dispatch(allActions.efectuarIngreso(...args));
        clearSeleccionadosLocalStorage();
        return result;
    };
    wrappedActions.cancelarIngreso = (...args) => {
        const result = dispatch(allActions.cancelarIngreso(...args));
        clearSeleccionadosLocalStorage();
        return result;
    };

    return wrappedActions;
};

class IngresoContainer extends React.Component {
    componentDidMount() {
        if (
            (!this.props.seleccionados || this.props.seleccionados.length === 0)
            && getSeleccionadosFromLocalStorage().length > 0
        ) {
            if (this.props.setSeleccionados) {
                this.props.setSeleccionados(getSeleccionadosFromLocalStorage());
            }
        }
    }

    render() {
        return <Ingreso {...this.props} />;
    }
}
export default connect(ms2p, md2p)(IngresoContainer);
